import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { FormlyBootstrapModule } from '@ngx-formly/bootstrap';
import { FormlyModule } from '@ngx-formly/core';
import { FormComponent } from './forms.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { CommonModule } from "@angular/common";
import { FormDialogComponent } from "./form-dialog/form-dialog.component";
import { FileValueAccessor } from "./types/file-value-accessor";

/** configuration */
import { config } from './config/config';

/** types **/
import { FormlyFieldNgSelect } from "./types/ngselect.type";
import { FormlyFieldNgInput } from "./types/nginput.type";
import { ModalInputComponent } from "./types/madal.input.type";
import { FormlyFieldFile } from "./types/upload.file.type";


/** wrapper **/
import { ModalWrapperComponent } from "./wrappers/modal.wrapper";
import { Typologic } from './types/typologic.type';
import { FormlyFieldHtmlEditor } from './types/html-editor.type';
import { EditorModule, TINYMCE_SCRIPT_SRC } from '@tinymce/tinymce-angular';


@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    NgSelectModule,
    FormlyBootstrapModule,
    EditorModule,
    FormlyModule.forRoot(config)
  ],
  declarations: [
    FormComponent,
    FormlyFieldNgSelect,
    Typologic,
    FormlyFieldHtmlEditor,
    FormlyFieldNgInput,
    FormDialogComponent,
    ModalInputComponent,
    ModalWrapperComponent,
    FormlyFieldFile,
    FileValueAccessor
  ],
  providers: [{ provide: TINYMCE_SCRIPT_SRC, useValue: 'tinymce/tinymce.min.js' }],
  bootstrap: [],
})
export class FormlyWidgetModule { }
